// extracted by extract-css-chunks-webpack-plugin
module.exports = {"marketingOptInSection":"HPwI8","inputWrapper":"vuNSd","inputwithIcon":"KldM1","marketingOptInInput":"wdoYj","marketingOptInBtn":"_2wIpq"};